import Vue from 'vue';
import Vuex from 'vuex';
import preloader from './modules/preloader';
import userAgent from './modules/userAgent';
import * as contentSections from '@/data/sections';

Vue.use(Vuex);

let getNavName = str => {
  return `${str.split('-')[0].toLowerCase()}LastNav`;
};

export default new Vuex.Store({
  state: {
    preloaded: {},
    isActive: false,
    isIndicationActive: false,
    onDark: false,
    currentRoute: {},
    currentSection: '',
    tremfyaLastNav: '/tremfya/',
    psoriasisLastNav: '/psoriasis/',
    headerStatus: '',
    isTransitionAnimated: false,
    contentTitleScrollLock: true,
    currentMobileSubmenu: '',
    choosenMobileSubmenuItems: [],
    playHeaderTitle: false,
    btnScroll: false,
    targetIsIsi: false,
    wheelEvent: null,
    girlWaveNavGuardIndex: -1,
    switchWaveNavGuardIndex: -1,
    prevContentNav: '',
    homeIntroInited: false,
    explicitSectionName: '',
    explicitSubsectionName: '',
    explicitSlideIndex: '',
    changedDataLayer: null,
    psoriasisScrollPos: 0,
    tremfyaScrollPos: 0,
    s3Link: process.env.VUE_APP_S3PATH ? process.env.VUE_APP_S3PATH : ''
  },
  modules: {
    preloader,
    userAgent
  },
  mutations: {
    tremfya_last_nav: (state, payload) => {
      state.tremfyaLastNav = payload;
    },
    psoriasis_last_nav: (state, payload) => {
      state.psoriasisLastNav = payload;
    },
    SCROLL_ISI: (state, payload) => {
      state.targetIsIsi = payload;
    },
    BTN_SCROLL: (state, payload) => {
      state.btnScroll = payload;
    },
    ISI_STATE: (state, payload) => {
      state.isActive = payload;
    },
    INDICATION_STATE: (state, payload) => {
      state.isIndicationActive = payload;
    },
    setCurrentSection(state, payload) {
      if (payload.subsection && payload.subsection !== 'undefined') {
        state.currentSection = `${payload.section}.${payload.subsection}`;
        return;
      }
      state.currentSection = `${payload.section}`;
    },
    setContentTitleScrollLock(state, payload) {
      state.contentTitleScrollLock = payload;
    },
    setTransitionAnimated(state, payload) {
      state.isTransitionAnimated = payload;
    },
    setPlayHeaderTitle(state, payload) {
      state.playHeaderTitle = payload;
    },
    setRouteFromObj(state, payload) {
      state.currentRoute = payload;
      state[getNavName(payload.name)] = payload;
    },
    setRouteFromParams(state, payload) {
      let obj = payload;
      obj.name = payload.params.subsection
        ? `${payload.name}-subsection`
        : `${payload.name}-section`;
      state.currentRoute = obj;
      state[getNavName(payload.name)] = obj;
    },
    setHeaderStatus(state, payload) {
      state.headerStatus = payload;
    },
    setWheelEvent(state, payload) {
      state.wheelEvent = payload;
    },
    setGirlWaveNavGuardIndex(state, payload) {
      state.girlWaveNavGuardIndex = payload;
    },
    setSwitchWaveNavGuardIndex(state, payload) {
      state.switchWaveNavGuardIndex = payload;
    },
    setPrevContentNav(state, payload) {
      state.prevContentNav = payload;
    },
    setHomeIntroInited(state, payload) {
      state.homeIntroInited = payload;
    },
    setExplicitSection(state, payload) {
      state.explicitSectionName = payload;
    },
    setExplicitSubsection(state, payload) {
      state.explicitSubsectionName = payload;
    },
    setExplicitSlideIndex(state, payload) {
      state.explicitSlideIndex = payload;
    },

    // push to Datalayer
    updateDataLayer(state, payload) {
      state.changedDataLayer = payload;
    }
  },
  actions: {},
  getters: {
    activeSection(state, getters) {
      if (state.route.params.section) {
        let num = state.route.params.section;
        return contentSections[getters.page][num - 1];
      }
    },

    activeMobileSubection(state, getters) {
      if (state.route.params.section) {
        let order = state.currentMobileSubmenu;
        return contentSections[getters.page][order - 1];
      }
    },

    menuSections(state, getters) {
      return contentSections[getters.page];
    },
    menuGlobalName(state, getters) {
      return getters.page === 'psoriasis'
        ? 'PLAQUE PSORIASIS'
        : 'TREMFYA<sup>®</sup>';
    },
    page(state) {
      if (state.route.meta.page) {
        return state.route.meta.page.toLowerCase();
      }
    },
    hasContent(state, getters) {
      if (
        getters.activeSection &&
        getters.activeSection.content === false &&
        getters.activeSubsection === undefined
      ) {
        return false;
      }
      return true;
    },
    hasSubsections(state, getters) {
      if (
        getters.activeSection &&
        !getters.activeSection.hasOwnProperty('subsections')
      ) {
        return false;
      }
      return true;
    },
    activeSubsection(state, getters) {
      if (state.route.params.subsection) {
        let subs = state.route.params.subsection;
        if (subs) {
          return getters.activeSection.subsections[subs - 1].name;
        }
      }
    },
    activeTitleAnimDuration(state, getters) {
      let sec = getters.activeSection;
      let subsec = null;
      let animTime = '0.5';

      if (state.route.params.subsection) {
        let subs = state.route.params.subsection;
        if (subs) {
          subsec = sec.subsections[subs - 1];
        }
      }

      if (sec && subsec) {
        if (subsec.hasOwnProperty('animTitleTime')) {
          animTime = subsec.animTitleTime;
        }
      } else if (sec && sec.hasOwnProperty('animTitleTime')) {
        animTime = sec.animTitleTime;
      }

      return animTime;
    },
    canScroll(state, getters) {
      if (!getters.hasContent) {
        return true;
      }
      if (!state.contentTitleScrollLock) {
        return true;
      }
      if (state.contentTitleScrollLock) {
        return false;
      }
    }
  }
});
